export default "__VITE_ASSET__CKfRxo3u__"